export default function getDimensionsConstrainedToContainerWidth(elementDimensions, containerDimensions) {
    let newDimensions = {
        width: containerDimensions.width,
        height: parseInt((containerDimensions.width / elementDimensions.width) * elementDimensions.height, 10)
    };

    return containerDimensions.width > elementDimensions.width ? elementDimensions : newDimensions;
}


// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/dom/getDimensionsConstrainedToContainerWidth.js